import * as React from 'react'
import styled from 'styled-components'
import CheckIcon from '@components/shared/icons/CheckIcon'
import { colors, OutlineOnFocusVisible } from '@components/shared'
import { config } from 'react-awesome-styled-grid'

type OwnPropsType = {
  name: string,
  onClick: (event: any) => void,
  faded: boolean,
  selected: boolean,
  showHover: boolean,
  text: string,
  arialLabel: string,
  bannerText?: string,
  trialText?: string
}

export function PlanOption (props: OwnPropsType): React.ReactNode {
  const {
    name,
    onClick,
    faded,
    selected,
    showHover,
    text,
    arialLabel,
    bannerText,
    trialText
  } = props
  return (
    <PlanOptionButtonContainer>
      <PlanOptionButton
        className={name}
        onClick={onClick}
        onKeyDown={(event: any): void => {
          if (event.keyCode === 13) {
            onClick(event)
          }
        }}
        faded={faded}
        selected={selected}
        showHover={showHover}
        role="button"
        tabIndex={0}
        aria-label={arialLabel}
      >
        {!!bannerText && (
          <MostPopularBanner>
            <MostPopularText>{bannerText}</MostPopularText>
          </MostPopularBanner>
        )}

        <CheckContainer>
          {selected && <CheckIcon />}
        </CheckContainer>

        <ButtonTextContainer>
          <p className="price">{text}</p>
          {!!trialText && <p className="trial">{trialText}</p>}
        </ButtonTextContainer>

      </PlanOptionButton>
    </PlanOptionButtonContainer>
  )
}

const MostPopularBanner = styled.div<any>`
  background-color: ${colors.accentBlue};
  align-self: flex-end;
  padding: 0 12px;
  border-radius: 100px;
  position: absolute;
  top: -12px; 
  right: 12px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`
const MostPopularText = styled.p<any>`
  color: ${colors.white};
  font-family: 'Good Sans Bold';
  font-style: normal;
  font-size: 12px;
  line-height: 12px;
  padding: 0;
  margin: 0;
`

const PlanOptionButtonContainer = styled.div<any>`
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 0 0 13px;
  position: relative;
`
const PlanOptionButton = styled.div<any>`
  align-items: center;
  background: ${(props: any): any => props.selected ? colors.white15 : 'none'};
  border-radius: 10px;
  color: ${colors.white};
  border: 1px solid ${colors.white};
  cursor: pointer;
  display: flex;
  flex: 1;
  flex-direction: row;
  max-width: 455px;
  min-height: 70px;
  outline: none;
  position: relative;
  :hover {
    background: ${(props: any): any => props.selected ? colors.white15 : colors.white10};
  }

  ${OutlineOnFocusVisible}
`

const ButtonTextContainer = styled.div<any>`
  flex: 1;
  padding: 15px 0;
  p {
    color: ${colors.white};
    padding: 0;
    margin: 0;
  }
  p.price {
    font-family: 'Good Sans Bold';
    font-size: 14px;
    line-height: 1.2em;
  }
  p.trial {
    font-family: 'Good Sans Light';
    font-size: 12px;
    margin-top: .4em;
    line-height: 1em;
  }

  ${(props: any): any => config(props).media.md`
    p.price {
      font-size: 16px;
    }
    p.trial {
      font-size: 14px;
    }
  `}
`
const CheckContainer = styled.div<any>`
  align-content: center;
  display:flex;
  justify-content: center;
  width: 34px;
`
